import { gql } from "apollo-boost"

export const UPDATE_ACTIVITIES_ORDER_INDEX = gql`
  mutation ActivityResolver ($data: [UpdateActivityOrderIndexInput!]!) {
    UpdateActivitiesOrderIndex(data: $data)
  }
`